export default "__VITE_ASSET__CyvQL11u__"